module.exports = __webpack_public_path__ + "5bd43ee0232f6abd05af1a18c0e59deb.otf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Italic.otf
// module id = 15
// module chunks = 0